import QRCode from 'qrcode';

/** Renders a trade code (T- / S- / O-) as a PNG data URL, or null when the code is blank or rendering fails. */
export async function renderQrDataUrl(code: string | null | undefined, width = 256): Promise<string | null> {
  const value = code?.trim() || '';
  if (!value) {
    return null;
  }
  try {
    return await QRCode.toDataURL(value, {errorCorrectionLevel: 'M', margin: 1, width});
  } catch {
    return null;
  }
}

/** Triggers a browser download of a rendered QR image. */
export function downloadQrImage(qrImageUrl: string | null, fileName: string): void {
  if (!qrImageUrl) {
    return;
  }
  const anchor = document.createElement('a');
  anchor.href = qrImageUrl;
  anchor.download = `${fileName || 'qr-code'}.png`;
  anchor.click();
}
